import { render, staticRenderFns } from "./STableHeader.vue?vue&type=template&id=24cef462&scoped=true&"
var script = {}
import style0 from "./STableHeader.vue?vue&type=style&index=0&id=24cef462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cef462",
  null
  
)

export default component.exports